<template>
  <div class="page-wrap">
    <el-card shadow="never">
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column type="index" width="60" label="#" />
        <el-table-column label="订单号" prop="orderNo" width="200" show-overflow-tooltip />
        <el-table-column label="订单类型" width="110">
          <template #default="{ row }">
            <el-tag :type="orderTypeTag(row.orderType)" size="small">
              {{ row.orderTypeLabel || '—' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="购买人" min-width="120">
          <template #default="{ row }">
            {{ row.buyerName || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="真实姓名" width="100">
          <template #default="{ row }">
            {{ row.buyerRealName || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="商品名称" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">
            <span>{{ row.productName || '—' }}</span>
            <span v-if="row.exportCount" class="export-count">（{{ row.exportCount }}次）</span>
          </template>
        </el-table-column>
        <el-table-column label="金额（元）" width="100">
          <template #default="{ row }">
            {{ formatAmount(row.amount) }}
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="90">
          <template #default="{ row }">
            {{ row.payChannelLabel || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="支付状态" width="100">
          <template #default="{ row }">
            <el-tag :type="payStatusType(row.payStatus)" size="small">
              {{ row.payStatusLabel || '—' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" prop="payTime" width="170" />
        <el-table-column label="创建时间" prop="createdAt" width="170" />
        <el-table-column label="交易号" prop="transactionId" min-width="160" show-overflow-tooltip />
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        :total="total"
        layout="total, sizes, prev, pager, next"
      />
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'

export default {
  name: 'OrderList',
  data() {
    return {
      tableData: [],
      page: 0,
      size: 10,
      total: 0,
      loading: false
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    formatAmount(amount) {
      const n = Number(amount)
      return Number.isFinite(n) ? n.toFixed(2) : amount
    },
    payStatusType(status) {
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'warning'
    },
    orderTypeTag(type) {
      if (type === 'TEACHER_EXPORT') return 'primary'
      if (type === 'STUDENT_WRONG_EXPORT') return 'warning'
      return 'success'
    },
    loadList() {
      this.loading = true
      request.get('/order/list', { params: { page: this.page, size: this.size } })
        .then(data => {
          this.tableData = data.content || []
          this.total = data.totalElements || 0
        }).finally(() => { this.loading = false })
    },
    handlePageChange(val) { this.page = val - 1; this.loadList() },
    handleSizeChange(val) { this.size = val; this.page = 0; this.loadList() }
  }
}
</script>

<style scoped>
.pagination { margin-top: 16px; text-align: right; }
.export-count { color: #909399; font-size: 12px; }
</style>
